module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lD82P"))).then(() => parcelRequire('1iHdE'));